import styles from "./Topbanner.module.scss";
import Link from 'next/link';
import Image from "next/image";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

if (process.client) {
    gsap.registerPlugin(ScrollToPlugin);
}

function Topbanner(props) {
    const handleClick = (e) => {
        gsap.registerPlugin(ScrollToPlugin);
        e.stopPropagation()
        gsap.to(window, {
            duration: 1,
            scrollTo: {
                y: `${props.target}`,
                offsetY: 70,
            }
        })
    }
    return (
        <>
            <section className={styles.top_banner} style={{ backgroundImage: `url(${props.bgImage})` }} >
                <div className={styles.banner_text}>
                    <div className='container common_title'>
                        <h1 className="animate_title" suppressHydrationWarning>{props.title}</h1>
                        {props.button ? (
                            <Link href="/" className="common_btn">{props.button}</Link>
                        ) : ('')}
                    </div>
                </div>
                {/* <div className={styles.banner_btn} onClick={handleClick}>
                    <Image src='/icons/down-arrow.svg' height={40} width={40} alt='Down Icon'></Image>
                </div> */}
            </section>
        </>
    )
}
export default Topbanner;